function hexToRGB(hex) {
  // Remove the # character from the beginning of the hex code
  hex = hex.replace('#', '');

  // Convert the hex code to three separate values for red, green, and blue
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Return the RGB color as an object with properties for red, green, and blue
  return { r, g, b };
}


export function convertImageColors(imageData, colors) {
  const { primary, dark, target } = colors;

  const opacity = 0.32;
  const primaryRGB = hexToRGB(primary);
  const darkRGB = hexToRGB(dark);
  const targetRGB = hexToRGB(target);

  for (let i = 0; i < imageData.data.length; i += 4) {
    const r = imageData.data[i];
    const g = imageData.data[i + 1];
    const b = imageData.data[i + 2];

    if (r <= targetRGB.r && g <= targetRGB.g && b <= targetRGB.b) {
      imageData.data[i] = darkRGB.r;
      imageData.data[i + 1] = darkRGB.g;
      imageData.data[i + 2] = darkRGB.b;
      imageData.data[i + 3] = 255;
    } else {
      imageData.data[i] = primaryRGB.r;
      imageData.data[i + 1] = primaryRGB.g;
      imageData.data[i + 2] = primaryRGB.b;
      imageData.data[i + 3] = opacity * 255;
    }
  }

  return imageData;
}

export function worldSeaRegions(){
  const REGION_BOUNDS = {
    mediterranean: {
      name: "Mediterranean Sea",
      latRange: [30, 46],
      lngRange: [-6, 36],
    },
    redSea: {
      name: "Red Sea",
      latRange: [12, 30],
      lngRange: [32, 44],
    },
    arabianSea: {
      name: "Arabian Sea",
      latRange: [10, 25],
      lngRange: [50, 77],
    },
    persianGulf: {
      name: "Persian Gulf",
      latRange: [24, 30],
      lngRange: [48, 56],
    },
    bayOfBengal: {
      name: "Bay of Bengal",
      latRange: [5, 22],
      lngRange: [80, 100],
    },
    gulfOfThailand: {
      name: "Gulf of Thailand",
      latRange: [6, 14],
      lngRange: [98, 105],
    },
    southChinaSea: {
      name: "South China Sea",
      latRange: [0, 25],
      lngRange: [100, 120],
    },
    eastChinaSea: {
      name: "East China Sea",
      latRange: [23, 47],
      lngRange: [118, 142],
    },
    gulfOfMexico: {
      name: "Gulf of Mexico",
      latRange: [18, 31],
      lngRange: [-97, -81],
    },
    caribbeanSea: {
      name: "Caribbean Sea",
      latRange: [9, 23],
      lngRange: [-85, -60],
    },
    bandaSea: {
      name: "Banda Sea",
      latRange: [-10, -2],
      lngRange: [120, 130],
    },
    philippineSea: {
      name: "Philippine Sea",
      latRange: [10, 30],
      lngRange: [125, 150],
    },
    coralSea: {
      name: "Coral Sea",
      latRange: [-28, -10],
      lngRange: [142, 160],
    },
    andamanSea: {
      name: "Andaman Sea",
      latRange: [5, 15],
      lngRange: [92, 100],
    },
    labradorSea: {
      name: "Labrador Sea",
      latRange: [50, 70],
      lngRange: [-60, -40],
    },
    hudsonBay: {
      name: "Hudson Bay",
      latRange: [50, 70],
      lngRange: [-95, -75],
    },
    greatAustralianBight: {
      name: "Great Australian Bight",
      latRange: [-40, -30],
      lngRange: [120, 140],
    },
    tasmanSea: {
      name: "Tasman Sea",
      latRange: [-47, -30],
      lngRange: [147, 170],
    },
    blackSea: {
      name: "Black Sea",
      latRange: [40, 47],
      lngRange: [27, 42],
    },
    balticSea: {
      name: "Baltic Sea",
      latRange: [53, 66],
      lngRange: [9, 30],
    },
    seaOfOkhotsk: {
      name: "Sea of Okhotsk",
      latRange: [43, 62],
      lngRange: [135, 162],
    },
    beringSea: {
      name: "Bering Sea",
      latRange: [52, 66],
      lngRange: [160, -160],
    },
    gulfOfGuinea: {
      name: "Gulf of Guinea",
      latRange: [-5, 7],
      lngRange: [-20, 15],
    },
    aegeanSea: {
      name: "Aegean Sea",
      latRange: [35, 41],
      lngRange: [23, 29],
    },
    caspianSea: {
      name: "Caspian Sea",
      latRange: [36, 47],
      lngRange: [48, 54],
    },
    norwegianSea: {
      name: "Norwegian Sea",
      latRange: [62, 75],
      lngRange: [-5, 10],
    },
    northAtlanticOcean: {
      name: "North Atlantic Ocean",
      latRange: [30, 70],
      lngRange: [-80, 10],
    },
    southAtlanticOcean: {
      name: "South Atlantic Ocean",
      latRange: [-60, 30],
      lngRange: [-70, 20],
    },
    northPacificOcean: {
      name: "North Pacific Ocean",
      latRange: [0, 65],
      lngRange: [120, -100],
    },
    southPacificOcean: {
      name: "South Pacific Ocean",
      latRange: [-60, 0],
      lngRange: [120, -70],
    },
    indianOcean: {
      name: "Indian Ocean",
      latRange: [-50, 30],
      lngRange: [20, 110],
    },
    southernOcean: {
      name: "Southern Ocean",
      latRange: [-90, -50],
      lngRange: [-180, 180],
    },
    arcticOcean: {
      name: "Arctic Ocean",
      latRange: [70, 90],
      lngRange: [-180, 180],
    },
    unitedStates: {
      name: "United States",
      latRange: [24, 49], // From the southernmost to the northernmost point
      lngRange: [-125, -66], // From the westernmost to the easternmost point
    },
  };
  return REGION_BOUNDS
}